// utils/onboarding.js
export const STEP_ORDER = [
  "welcome", // anonymous user just arrived
  "planSelected", // chose plan on Payment page
  "accountCreated", // registered (email+password)
  "paymentComplete", // Stripe (or similar) success webhook/return
  "formStarted", // opened form at least once
  "formComplete", // finished questionnaire
];

export function stepIndex(step) {
  const idx = STEP_ORDER.indexOf(step || "welcome");
  return idx === -1 ? 0 : idx;
}

export function atLeast(step, target) {
  return stepIndex(step) >= stepIndex(target);
}
